import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/authContext';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, loading, isOptimistic, isDeletingAccount, setIsDeletingAccount } = useAuth();
    const location = useLocation();

    // Preserve deletion result view on /account-settings only even after session clear
    if (isDeletingAccount) {
        if (location.pathname === '/account-settings') {
            return <>{children}</>;
        }
        // Navigated away to an unrelated protected route: clear temporary deletion state
        setIsDeletingAccount(false);
    }

    // OPTIMIZATION: Show content immediately if optimistic auth
    if (isOptimistic) {
        return <>{children}</>;
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
